import SupportAgentIcon from "@mui/icons-material/SupportAgent";

const icons = {
    SupportAgentIcon,
};

const feedbackCalling = {
    id: "feedback_calling",
    type: "group",
    children: [
        {
            id: "feedback_calling_ui",
            title: "Feedback Calling",
            type: "item",
            url: "/feedbackCalling",
            icon: icons.SupportAgentIcon,
        },
    ],
};

export default feedbackCalling;
